import { Box, Button, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { Formik } from 'formik';
import React from 'react';
import { MFTextField } from '../../lib/formik';
import CloseIcon from '@mui/icons-material/Close';
import * as yup from 'yup';
import { ApplicationProps } from '../../redux-store/types/api-types';

export const SendBackDialog = ({
  openSendBackDialog,
  handleSendBackClose,
  onSendBackSubmit,
  children,
}: {
  openSendBackDialog: boolean;
  handleSendBackClose: () => void;
  onSendBackSubmit: (values: Partial<ApplicationProps>) => void;
  children: JSX.Element;
}): JSX.Element => {
  const initialCommentValues: Partial<ApplicationProps> = { comment: '' };
  const Commentvalidation = yup.object().shape({
    comment: yup.string().required('Please provide Comment'),
  });
  return (
    <Dialog
      onClose={handleSendBackClose}
      open={openSendBackDialog}
      sx={{
        '.MuiPaper-root ': {
          p: 4,
          width: { xs: '70%', sm: '70%' },
        },
      }}>
      <IconButton onClick={handleSendBackClose} sx={{ alignSelf: 'flex-end' }}>
        <CloseIcon fontSize="small" />
      </IconButton>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          mx: 'auto',
          '.MuiTypography-root': {
            fontSize: 18,
            fontWeight: 500,
            textAlign: 'center',
          },
        }}>
        {children}
        <Formik
          initialValues={initialCommentValues}
          onSubmit={onSendBackSubmit}
          validationSchema={Commentvalidation}>
          {({ handleSubmit }) => (
            <Box component="form" noValidate onSubmit={handleSubmit}>
              <MFTextField
                name="comment"
                multiline
                rows={4}
                placeholder="Type your answer here..."
              />

              <Grid container sx={{ my: 3, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={handleSendBackClose}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  type="submit">
                  Continue
                </Button>
              </Grid>
            </Box>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
};
